export enum EarlyPayoutSubscriptionSource {
    MyBets = 'mybets',
    EditBet = 'editbet',
}
